import { useCallback } from "react";
import { LocalizationApi, useAPIAction } from "melco-shared-logic";
import { EditLocaleStringFormValueType } from "../../components/localestrings/form/EditLocaleStringForm";
import { PRODUCT_CODE } from "../../helper/localestringHelper";

export const useEditLocaleStrings = () => {
  const [editLocaleStrings] = useAPIAction(
    LocalizationApi,
    async (api, EditLocaleStringsDetails: EditLocaleStringFormValueType) => {
      const data = await api.localizationEdit({
        id: EditLocaleStringsDetails.id,
        moduleCode: PRODUCT_CODE,
        controlcenterMelcoModelsLocaleString: {
          strings: EditLocaleStringsDetails.strings,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "localestrings.actions.update",
    }
  );

  return useCallback(
    async (forwardLinkDetails: EditLocaleStringFormValueType) => {
      return await editLocaleStrings(forwardLinkDetails);
    },
    [editLocaleStrings]
  );
};
